import { memo } from 'react';

import AuthPageLayout from '@/domain/auth/components/AuthPageLayout';
import SignInCard from '@/domain/auth/components/SignInCard';

const SignInSide = () => (
  <AuthPageLayout variant="signin">
    <SignInCard />
  </AuthPageLayout>
);

export default memo(SignInSide);
